<template>
    <div v-show="isModalAddUserToLocationVisible">
        <transition name="slide">
            <div class="modal-mask">
                <div class="modal-dialog modal-dialog-slideout modal-lg">
                    <div class="modal-content p-2">
                        <div class="modal-header">
                            <div class="maheading_1">
                                <i class="fa fa-chevron-left modal-goback" @click="close"></i>
                            </div>
                            <div class="maheading_2">
                                <h5 class="modal-title">{{ accountName }} - {{  getBtnName }}</h5>
                            </div>
                            <div class="maheading_3">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                            <form>
                                <div class="row">
                                    <div class="col-12">
                                        <label class="form-label">
                                            User Information
                                            <span class="required">*</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <input
                                            type="text"
                                            id="first_name"
                                            class="col-12 col-sm-12 ma-input-field"
                                            ref="first_name"
                                            name="first_name"
                                            v-model="first_name"
                                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                            placeholder="First Name"
                                            maxlength="180"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('first_name', 'required')" :class="'validate-warning-msg ' + vmessage">First Name is required</div>
                                        <div v-if="verrors.firstByRule('first_name', 'regex')" :class="'validate-warning-msg ' + vmessage">First Name should only contain - and _</div>
                                    </div>
                                    <div class="col-6">
                                        <input
                                            type="text"
                                            id="last_name"
                                            class="col-12 col-sm-12 ma-input-field"
                                            ref="last_name"
                                            name="last_name"
                                            v-model="last_name"
                                            v-validate="{ rules: { required: true, regex: nameRegex() } }"
                                            placeholder="Last Name"
                                            maxlength="180"
                                            autocomplete="off">
                                        <div v-if="verrors.firstByRule('last_name', 'required')" :class="'validate-warning-msg ' + vmessage">Last Name is required</div>
                                        <div v-if="verrors.firstByRule('last_name', 'regex')" :class="'validate-warning-msg ' + vmessage">Last Name should only contain - and _</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-12 col-sm-12">
                                                <input
                                                    type="text"
                                                    id="email"
                                                    class="col-12 ma-input-field"
                                                    ref="email"
                                                    name="email"
                                                    v-validate="'required|email'"
                                                    v-model="email"
                                                    placeholder="Email Address"
                                                    maxlength="180"
                                                    autocomplete="off">
                                                    <div v-if="verrors.has('email')" :class="'validate-warning-msg ' + vmessage">Email address is required</div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12">
                                                <input
                                                type="text"
                                                id="phone_number"
                                                class="col-12 col-sm-12 ma-input-field"
                                                ref="phone_number"
                                                name="phone_number"
                                                v-model="phone_number"
                                                placeholder="Phone Number"
                                                @keyup="adminPhoneValid($event)"
                                                @blur="adminPhoneValid($event)"
                                                v-validate="{ rules: { regex: adminPhoneRegex() } }"
                                                maxlength="14"
                                                autocomplete="off">
                                                <div v-if="verrors.has('phone_number')" :class="'validate-warning-msg ' + vmessage">Phone number is invalid</div>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-12">
                                                <label class="form-label">
                                                    User Type:
                                                <span class="required">*</span>
                                            </label>
                                            </div>
                                            <div class="col-12">
                                                <b-form-select
                                                    name="user_role"
                                                    id="user_role"
                                                    class="col-12 ma-input-field"
                                                    v-model="user_role"
                                                    :options="roles_options"
                                                    v-validate="'required'"
                                                    @change="changeUserRole">
                                                </b-form-select>
                                                <div v-if="verrors.firstByRule('user_role', 'required')" :class="'validate-warning-msg ' + vmessage">User Type is required</div>
                                            </div>
                                        </div>
                                        <div class="row mt-1" v-if="(user_role == 'ROLE_MENTEE' || user_role == 'ROLE_APPRENTICE')">
                                            <div class="col-6 col-sm-6">
                                                <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text">$</span>
                                                    </div>
                                                    <input
                                                    type="text"
                                                    name="compensation"
                                                    id="compensation"
                                                    class="form-control"
                                                    ref="compensation"
                                                    v-validate="'required|numeric'"
                                                    v-model="compensation"
                                                    data-vv-as="Starting Compensation"
                                                    maxlength="5">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text">/hr</span>
                                                    </div>
                                                </div>
                                                <div v-show="verrors.has('compensation')" :class="'validate-warning-msg ' + vmessage">{{ verrors.first('compensation') }}</div>
                                            </div>
                                            <div class="col-6 col-sm-6">
                                                <date-picker
                                                    v-model="review_compensation"
                                                    :disabled-date="notBeforeToday"
                                                    format="MM/DD/YYYY"
                                                    v-bind:clearable="false"
                                                    v-bind:editable="false"
                                                    input-class="col-12 input-height-35"
                                                    :popup-style="datePickerStyle"
                                                    >
                                                    <template v-slot:icon-calendar>
                                                        <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                                                    </template>
                                                </date-picker>
                                                <div v-show="verrors.has('review_compensation')" :class="'validate-warning-msg ' + vmessage">{{ verrors.first('review_compensation') }}</div>
                                            </div>
                                        </div>
                                        <div class="row mt-1" v-if="(user_role == 'ROLE_MENTEE' || user_role == 'ROLE_APPRENTICE')">
                                            <div class="col-12" id="mentor-group-wrapper">
                                                <multiselect v-model="mentor_assigned"
                                                    :options="groups"
                                                    track-by="value"
                                                    label="text"
                                                    placeholder="Select Mentor(s)"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :show-labels="false"
                                                    v-bind:name="'mentor_assigned[]'"
                                                    v-bind:id="'mentor_assigned'"
                                                    v-validate="'required'">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ getMentorDisplayText(values.length, values) }}</span></template>
                                                </multiselect>
                                                <div v-if="verrors.firstByRule('mentor_assigned[]', 'required')"  :class="'margin-bottom-5 validate-warning-msg ' + vmessage">Mentor(s) is required</div>
                                            </div>
                                        </div>
                                        <div class="row mt-1" v-if="tasklists.length > 0 && (user_role == 'ROLE_MENTEE' || user_role == 'ROLE_APPRENTICE')">
                                            <div class="col-12">
                                                <label class="form-label">TaskLists</label>
                                                <div class="row row_data_border">
                                                    <div class="col-12" v-for="(pitem, aindex) in tasklists" :key="aindex">
                                                        <input
                                                            type="checkbox"
                                                            :id="'tasklist_assigned_' + aindex"
                                                            name="tasklist_assigned"
                                                            v-model="tasklist_assigned"
                                                            :value="pitem.id">
                                                        <label :for="'tasklist_assigned_' + aindex">{{ pitem.name }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1" v-if="courses.length > 0 && user_role">
                                            <div class="col-12">
                                                <label class="form-label">Courses</label>
                                                <div class="row row_data_border">
                                                    <div class="col-12" v-for="(pitem, sindex) in courses" :key="sindex">
                                                        <input
                                                            type="checkbox"
                                                            :id="'course_assigned_' + sindex"
                                                            name="course_assigned"
                                                            v-model="courseSelected"
                                                            :value="pitem.id">
                                                        <label :for="'course_assigned_' + sindex">{{ pitem.name }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row row_data_border" v-if="assessments.length > 0 && user_role">
                                            <div class="col-12">
                                                <label class="form-label">Assessments</label>
                                                <div class="row row_data_border">
                                                    <div class="col-12" v-for="(pitem, aindex) in assessments" :key="aindex">
                                                        <input
                                                            type="checkbox"
                                                            :id="'assessment_assigned_' + aindex"
                                                            name="assessment_assigned"
                                                            v-model="assessmentSelected"
                                                            :value="pitem.id">
                                                        <label :for="'assessment_assigned_' + aindex">{{ pitem.name }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center end_btn">
                                    <button type="button" :class="'btn btn-sm text-center ' + getBtnClass" @click="onSubmit">{{ getBtnName }}</button>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import DatePicker from 'vue2-datepicker';
import Multiselect from 'vue-multiselect';

const today = new Date();
today.setHours(0, 0, 0, 0);

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalAddUserToLocationVisible', 'accountId', 'accountName', 'userRoleType', 'rolename'],
    data() {
        return {
            loading: false,
            first_name: '',
            last_name: '',
            phone_number: '',
            email: '',
            password: '',
            assessments: [],
            assessmentSelected: [],
            courses: [],
            courseSelected: [],
            user_role: '',
            roles_options: [],
            tasklists: [],
            tasklist_assigned: [],
            compensation: '',
            review_compensation: today,
            groups: [],
            mentor_assigned: [],
            datePickerStyle: {},
            vmessage: "",
            mentorSelected: [],
        }
    },
    components: {
        DatePicker,
        Multiselect,
    },
    computed: {
        getBtnClass() {
            if (this.first_name && this.last_name && this.email && this.user_role) {
                return 'saveBtn';
            } else {
                return 'greyBtn';
            }
        },
        getBtnName() {
            if (this.rolename) {
                return "Add New " + this.rolename;
            } else {
                return "Add New User";
            }
        }
    },
    methods: {
        close() {
            this.user_role = '';
            this.mentorSelected = [];
            this.courseSelected = [];
            this.assessmentSelected = [];
            this.tasklist_assigned = [];
            this.first_name = '';
            this.last_name = '';
            this.email = '';
            this.phone_number = '';
            this.compensation = '';
            this.vmessage = "hide_vmessage";
            this.roles_options = [];
            this.verrors.clear();
            this.$emit('close');
        },
        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        adminPhoneRegex: function() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        adminPhoneValid: function(event) {
            var phone_val = this.phone_number;
            this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        changeUserRole() {
            if (this.user_role == 'ROLE_MENTEE' || this.user_role == 'ROLE_APPRENTICE')  {
                this.getGroups();
                this.getTaskLists();
                this.datePickerStyle['left'] = '50%';
                this.datePickerStyle['top'] = '50%';
                this.datePickerStyle['transform'] = 'translate(-30%, -60%)';
                this.datePickerStyle['z-index'] = '9999';
            }
            if (this.user_role) {
                this.getCourses();
                this.getAssessments();
            }
        },
        getGroups() {
            this.groups = [];
            axios('/accountgroups',
                {
                method: 'GET',
                    params: {
                        account_id: this.accountId,
                    }
                },
            )
            .then(response => {
                for(var i=0; i < response.data.length; i++) {
                    var group = {value: response.data[i].id, text: response.data[i].groupName};
                    this.groups.push(group);
                }
            })
            .catch(error => {

            });
        },
        getTaskLists() {
            axios('/alltasklists-account',
                {
                    method: 'GET',
                    params: {
                        account_id: this.accountId,
                    }
                },
            )
            .then(response => {
                    this.tasklists = response.data;
            })
            .catch(error => {

            });
        },
        getCourses() {
            axios.get('/desktop/course-lists', {
                params: {
                    user_roles: this.user_role,
                    accountId: this.accountId
                }
            })
            .then(response =>  {
                this.courses = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        getAssessments() {
            axios.get('/desktop/assessment-builder-lists', {
                params: {
                    user_roles: this.user_role,
                    accountId: this.accountId
                }
            })
            .then(response =>  {
                this.assessments = response.data;
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        notBeforeToday(date) {
            return date < today;
        },
        onSubmit () {
            this.vmessage = "show_vmessage";
            this.$validator.validateAll().then((result) => {
                if(!result) {
                    return;
                }
                this.createUser();
            })
            .catch(() => {

            });
        },
        getMentorDisplayText(count, name) {
            if (count == 1) {
                return name[0].text;
            } else {
                var num = (count - 1);
                if (count > 2) {
                    var otherText = num + " Others";
                } else {
                    var otherText = num + " Other";
                }
                return name[0].text + ", +" + otherText;
            }
        },
        loadInitialData() {
            this.getGroups();
            this.getLocationDetail(this.accountId);
        },
        createUser() {
            var dataObj = {};
            this.mentorSelected = [];
            if (this.user_role == 'ROLE_ADMIN') {
                dataObj = {
                    "username": this.email,
                    "email": this.email,
                    "roles": ["ROLE_ADMIN", "ROLE_MENTOR"],
                    "first_name": this.first_name,
                    "last_name": this.last_name,
                    "phone_number": this.phone_number,
                    "enabled": true,
                    "signin_count": 0,
                    "account_id": this.accountId,
                    "assessments_assigned": this.assessmentSelected,
                    "course_assigned": this.courseSelected,
                };
            } 
            if (this.user_role == 'ROLE_MENTOR') {
                dataObj = {
                    "username": this.email,
                    "email": this.email,
                    "roles": [this.user_role],
                    "first_name": this.first_name,
                    "last_name": this.last_name,
                    "phone_number": this.phone_number,
                    "enabled": true,
                    "signin_count": 0,
                    "account_id": this.accountId,
                    "assessments_assigned": this.assessmentSelected,
                    "course_assigned": this.courseSelected,
                };
            } 
            if (this.user_role == 'ROLE_MENTEE' || this.user_role == 'ROLE_APPRENTICE') {
                //make axios call to the API
                for(var i=0; i < this.mentor_assigned.length; i++) {
                    this.mentorSelected.push(this.mentor_assigned[i].value);
                }
                dataObj = {
                    "username": this.email,
                    "email": this.email,
                    "roles": [this.user_role],
                    "first_name": this.first_name,
                    "last_name": this.last_name,
                    "phone_number": this.phone_number,
                    "compensation": this.compensation,
                    "review_compensation": this.review_compensation,
                    "mentor": this.mentorSelected,
                    "enabled": true,
                    "tasklists_assigned": this.tasklist_assigned,
                    "assessments_assigned": this.assessmentSelected,
                    "course_assigned": this.courseSelected,
                    "signin_count": 0,
                    "account_id": this.accountId,
                    "user_type": (this.user_role == 'ROLE_MENTEE') ? 'mentee' : 'apprentice',
                 };
            }
            axios('/enterprise-admin/users',
            {
                method: 'POST',
                data: dataObj,
            },
            )
            .then(response => {
                router.push('/location-window/' + this.accountId);
                window.location.reload();
            })
            .catch(error => {
                const fieldErrors =  [{}];
                // var errMsgObj = error.response.data.message;
                var errMsgObj = JSON.parse(error.response.data.message);
                Object.keys(errMsgObj).map(key => {
                    var newFieldErr = {field:key, msg:errMsgObj[key]};
                    fieldErrors.push(newFieldErr);
                });
                this.$validator.errors.add(fieldErrors);
            });
        },
        getLocationDetail(accountId) {
            if (accountId > 0) {
                this.accountId = accountId;
                this.loading = true;
                this.account = [];
                this.overview = {};
                axios('/enterprise-admin/location-overview',
                {
                    method: 'GET',
                    params: {
                        account_id: accountId,
                    }
                })
                .then(resp => {
                    this.loading = false;
                    if (this.userRoleType) {
                        this.roles_options.push(
                            { text: 'Select User Type', value: '' },
                            {text: this.rolename, value: this.userRoleType}
                        );
                    } else {
                        if (resp.data.program == 'Apprenticeship') {
                            this.roles_options.push(
                                { text: 'Select User Type', value: '' },
                                { text: 'Manager', value: 'ROLE_ADMIN' },
                                { text: 'Mentor', value: 'ROLE_MENTOR' },
                                //{ text: 'Apprentice', value: 'ROLE_APPRENTICE' }
                            );  
                        }
                        else if (resp.data.program == 'Mentorship') {
                            this.roles_options.push(
                                { text: 'Select User Type', value: '' },
                                { text: 'Manager', value: 'ROLE_ADMIN' },
                                { text: 'Mentor', value: 'ROLE_MENTOR' },
                                //{ text: 'Mentee', value: 'ROLE_MENTEE'  }
                            );
                        } else {
                            this.roles_options.push(
                                { text: 'Select User Type', value: '' },
                                { text: 'Manager', value: 'ROLE_ADMIN' },
                                { text: 'Mentor', value: 'ROLE_MENTOR' },
                                //{ text: 'Mentee', value: 'ROLE_MENTEE'  },
                                //{ text: 'Apprentice', value: 'ROLE_APPRENTICE' }
                            );
                        }
                    }
                })
                .catch(() => {
                });
            }
        }
    },
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.saveBtn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 100%;
}
.totalBtn {
  color: #707070; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 10px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;  
  background-color: #efefef;
  min-height: 38px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-size: 13px; font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; font-size: 14px;border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.total_price { color: #00acee; }
</style>
<style>
#mentor-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentor-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect__tags, .multiselect__input, .multiselect__single {
    background-color: #FFF !important;
}
.multiselect__input, .multiselect__single {
  border: none !important;
}
.end_btn { margin: 8rem auto auto auto; width: 50%; }
.greyBtn, .greyBtn:focus, .greyBtn:active{
    color: #FFF !important; 
    background-color: #c3c3c3 !important;
    border: 1px solid #c3c3c3 !important;
    border-radius: 10px;
    width: 100%;
}
.greyBtn:focus {
    box-shadow: none;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/add_new_user.vue